import React from 'react';
import PropTypes from 'prop-types';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow 
} from '@mui/material';

import AcTableCell from './AcTableCell';
import DcTableCell from './DcTableCell';

const ProfitShareRevenue = ({data}) => {

  const {
    acSockets,
    dcSockets,
    acGrossRevenue,
    acVatRevenue,
    acNetRevenue,
    dcGrossRevenue,
    dcVatRevenue,
    dcNetRevenue,
  } = data;

  const hasAC = acSockets > 0;
  const hasDC = dcSockets > 0;

  return (
    <div className="mb-6">
      <TableContainer        
        aria-label="ProfitShareRevenue" 
        sx={{
          borderCollapse: 'separate',
          borderRadius: '15px',
          border: '1px solid rgb(224, 224, 224)',
       }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <AcTableCell hasAC={hasAC} hasDC={hasDC} header data={'AC Sockets'}/>
              <DcTableCell hasAC={hasAC} hasDC={hasDC} header data={'DC Sockets'}/>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Revenue charged and collected</TableCell>
              <AcTableCell hasAC={hasAC} hasDC={hasDC} data={`£${acGrossRevenue.toFixed(2)}`}/>
              <DcTableCell hasAC={hasAC} hasDC={hasDC} data={`£${dcGrossRevenue.toFixed(2)}`}/>
            </TableRow>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Less VAT included in collection</TableCell>
              <AcTableCell hasAC={hasAC} hasDC={hasDC} data={`£${acVatRevenue.toFixed(2)}`}/>
              <DcTableCell hasAC={hasAC} hasDC={hasDC} data={`£${dcVatRevenue.toFixed(2)}`}/>
            </TableRow>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Net revenue</TableCell>
              <AcTableCell hasAC={hasAC} hasDC={hasDC} data={`£${acNetRevenue.toFixed(2)}`}/>
              <DcTableCell hasAC={hasAC} hasDC={hasDC} data={`£${dcNetRevenue.toFixed(2)}`}/>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default ProfitShareRevenue;

ProfitShareRevenue.propTypes = {
  data: PropTypes.object.isRequired,
};
